import React from 'react';
import Top from './Top';
import { Wrapper } from './styled';

const NavbarHome = () => {
  return (
    <Wrapper>
      <Top />
    </Wrapper>
  );
};

export default NavbarHome;
